import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import I18n from 'translations/i18n'
import { Flex, Button } from '@jisr-hr/design-system'
import { useForm, useFormState } from 'react-final-form'
import { isNextDay, isValidTime } from 'components/global/form/formNormalize'
import { TimePicker } from 'components/global/ds'

import { ReactComponent as CheckIcon } from '../icons/check.svg'
import { ReactComponent as CloseIcon } from '../icons/close.svg'

import Styles from '../ProposedCorrectionTime.module.css'

const ManuallyTime = ({
  type,
  detail,
  handleClose,
  time,
  setTime,
  status,
  punchType,
  isInNotRecorded,
  inTime,
  handleExit,
  error,
}) => {
  const { values } = useFormState()
  const { change } = useForm()
  const punchTime = values?.[type]?.punch_time || detail?.punchTime

  const isNext = isNextDay(inTime, time)

  const handleSubmit = () => {
    const newPunch = {
      isOutNext: isNext && type === 'out_punch',
      punch_time: time,
      reporting_method: 'manual',
      reporting_method_i18n: I18n.t('manual'),
    }

    change(type, newPunch)
    change(punchType, time)
    handleClose()

    if (type === 'in_punch' && values?.out_punch) {
      change('out_punch', {
        ...values?.out_punch,
        isOutNext: isNextDay(inTime, values?.out_punch.punch_time),
      })
    }
  }

  // const handleCancel = () => {
  //   setTime(values?.[type]?.punch_time);
  //   handleClose();
  // };

  const handleIntVal = () => {
    let defaultTime = ''
    if (punchTime) defaultTime = punchTime
    else if (type === 'in_punch') defaultTime = detail?.shift_start_time
    else if (type === 'out_punch') defaultTime = detail?.shift_end_time
    if (defaultTime) {
      setTime(defaultTime, isNext)
    }
  }

  React.useEffect(() => {
    handleIntVal()
  }, [detail])

  React.useEffect(() => {
    return () => {
      setTime('')
    }
  }, [])

  return (
    <Flex
      container
      className={classnames(Styles.manuallyContainer, error && Styles.error)}
    >
      <TimePicker
        nextDay={isNext && type === 'out_punch' && I18n.t('next_day')}
        value={time}
        onChange={(v) => setTime(v, isNextDay(inTime, v) && type === 'out_punch')}
        disabled={isInNotRecorded}
      />

      <Flex className={Styles.actions}>
        <Button
          size="medium"
          icon={<CheckIcon />}
          onClick={handleSubmit}
          disabled={!isValidTime(time) || status || isInNotRecorded}
          data-testid={`add-manual-${type}`}
        />
        <Button
          size="medium"
          variant="secondary"
          icon={<CloseIcon />}
          disabled={!values?.[type]}
          onClick={() => {
            setTime('')
            handleExit()
          }}
        />
      </Flex>
    </Flex>
  )
}

ManuallyTime.propTypes = {
  isInNotRecorded: PropTypes.bool,
  inTime: PropTypes.string,
  punchType: PropTypes.string,
  type: PropTypes.string,
  time: PropTypes.string,
  status: PropTypes.string,
  detail: PropTypes.shape(),
  handleClose: PropTypes.func,
  setTime: PropTypes.func,
  handleExit: PropTypes.func,
  error: PropTypes.bool,
}

export default React.memo(ManuallyTime)
